import type { JsonArray, JsonObject } from 'type-fest';

import { isObject } from '@frontend/utils';

import type { Init } from '../types';
import { getDoesBodyRequireModification } from './getDoesBodyRequireModification';

export const getIsBodyJsonSerializableObject = (
  body?: Init['body'],
): body is JsonObject | JsonArray =>
  getDoesBodyRequireModification(body) && isObject(body);
